// 3.3 — the Home-tab forms list: the same menu rows, standing (delta spec:
// "Menu actions from the Home tab SHALL navigate to chat"). Gated on a
// multiform registry (or a submitted single form — forms-corrections review
// entry, see FormsHeader's gate) so an untouched single-form tenant's Home tab
// stays untouched, and on the feature itself so non-forms tenants emit
// nothing. The Home tab sits outside the chat body's themed root, so the
// theme variables are re-applied here.

import { useNavigate } from 'react-router-dom';
import styles from './ConversationalForms.module.css';
import FormsMenuRows from './FormsMenu';
import { useConversationalForms } from './FormsContext';
import { formLifecycle } from './formsSelectors';
import { formsThemeVars } from './theming';

const FormsHomeList = () => {
    const navigate = useNavigate();
    const { active, registry, state, theme } = useConversationalForms();

    // Multiform is counted over *browsable* forms (store tracker 6.30): an
    // ambient form never appears here, so a tenant whose only extra form is
    // ambient keeps the untouched single-form Home tab — unless that one
    // browsable form has itself been submitted, in which case its Review
    // entry needs a way in here too (spec amendment 2026-08-16).
    if (!active || !registry) return null;
    const browsableForms = registry.forms.filter((f) => f.browsable);
    const anySubmitted = browsableForms.some(
        (f) => formLifecycle(state, f.objectId) === 'submitted'
    );
    if (browsableForms.length < 2 && !anySubmitted) return null;

    return (
        <div className={styles.homeForms} style={formsThemeVars(theme)} data-testid="cf-home-forms">
            <div className={styles.homeFormsHead}>Your Forms</div>
            <FormsMenuRows onAction={() => navigate('/Chat')} />
        </div>
    );
};

export default FormsHomeList;
